module.exports = __webpack_public_path__ + "diamond-image02.png?4da5253c945c5dae7bc1b1d27f8b37ed";